export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_12-bc2c62549c958432fc6ad6fb2376e939.jpg";